<template>
    <div>
        <allTitle ref="allTitle" />

        <el-dialog title="" :visible.sync="dialogVisible" width="800px" :before-close="handleClose" center
            class="zfCode">
            <div class="lock">
                <div class="left">

                    <div class="leftBottom">
                        <div class="fsize">
                            专属特权</div>
                        <div class="Zicon">
                            <div>
                                <img src="../assets/newImg5/SVG.png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    开通好物橱窗功能
                                </span>
                            </div>
                            <div style="margin-left: 20px;">
                                <img src="../assets/newImg5/SVG (1).png" alt=""
                                    style="vertical-align: middle;margin-left: 10px;">
                                <span style="vertical-align: middle;">
                                    头像加V
                                </span>
                            </div>
                            <div style="margin-top: 10px;">
                                <img src="../assets/newImg5/SVG (2).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    搜索至尊卡片
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="right">
                    <!-- <div class="rightTop">
                        <div> <img src="../assets/newImg5/二维码-公众号 1.svg" alt="">
                        </div>
                        <div style="margin-top: 30px;margin-left: 30px;">对公转账请添加客服专员小周进行操作</div>
                    </div> -->
                    <div class="rightBottom">
                        <div ref="qrcode" id="qrcode-container">
                        </div>
                        <div v-show="!ifShow" style="width: 120px;height: 120px;"></div>

                        <div style="margin-top: 20px;margin-left: 28px;text-align: center;">
                            <div>
                                <img src="../assets/newImg2/Vector@1x (8).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;margin-left: 10px;">微信扫码支付</span>
                            </div>
                            <div style="font-size: 32px;margin-top: 10px;">￥238.00<span
                                    style="font-size: 14px;">/年</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div style="width: 100%;display: flex;justify-content: center;">
                <img src="../assets/newImg5/lock.png" alt="" style="margin: auto;">

            </div>
            <div style="text-align: center;font-weight: 700;margin-top: 20px;">您尚未订阅此数据查看权限</div>
            <div style="text-align: center;margin-top: 20px;margin-bottom: 30px;">订阅请致电您的专属客服:13790921868(王志)</div> -->


        </el-dialog>
    </div>
</template>

<script>
import { addMember, getPersonVipStatusByOrderSn } from "@/api/user"
import QRCode from 'qrcodejs2';

export default {
    data() {
        return {
            dialogVisible: false,
            timer: null,
            ifShow: false,
        }
    },
    methods: {
        titleShow(msg) {
            this.$refs.allTitle.msg = msg
            this.$refs.allTitle.routerPath = null;
            this.$refs.allTitle.dialogVisible = true;
        },
        handleClose() {
            if (!this.ifShow) {
                return
            }
            this.dialogVisible = false
            clearInterval(this.timer)
            console.log('清除定时器了。');

            const container = document.getElementById('qrcode-container');
            container.innerHTML = ''; // 清空容器 
            this.ifShow = false

        },
        getCode(cat_one) {
            setInterval(() => {
                console.log(this.$refs.qrcode, 'this.$refs.qrcode');

            }, 1000);

            this.dialogVisible = true
            let param = {
                total_amount: 0.01, order_description: '一年会员', term: 1, mark: 1
            }
            addMember(param).then((res) => {

                new QRCode(this.$refs.qrcode, {
                    text: res.data.data.codeUrl,
                    width: 120,
                    height: 120
                });
                this.timer = setInterval(() => {
                    getPersonVipStatusByOrderSn({ orderNo: res.data.data.orderSn }).then((res) => {
                        console.log(res, 'resppp');

                        if (res.data.code == 200) {
                            this.dialogVisible = false
                            clearInterval(this.timer)
                            this.titleShow('支付成功')
                            this.$bus.$emit("zfSuccess", {
                            });

                        }

                    })
                }, 3000);
                this.ifShow = true

            })
        }
    },
    created() { },
    mounted() {
    }
}
</script>

<style lang=scss scoped>
::v-deep .zfCode .el-dialog {
    background-color: #E88B35;
}

::v-deep .zfCode .el-dialog--center .el-dialog__body {
    padding: 40px 20px 10px
}

::v-deep .zfCode .el-dialog__header {
    padding: 0px !important;
}


.lock {
    height: 238px;
    width: 100%;
    background-color: #E88B35;
    display: flex;
    box-sizing: border-box;

    .left {
        width: 50%;
        height: 100%;
        // background-color: pink;

        .leftTop {
            width: 100%;
            height: 50%;
            text-align: center;
            color: white;
            font-size: 24px;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
        }

        .leftBottom {
            width: 93%;
            height: 90%;
            background-color: #EA6B4A;
            color: white;
            font-size: 14px;
            border-radius: 10px;

            .fsize {
                padding: 50px 0px 10px;
                width: 73%;
                margin: auto;
                font-weight: 600;
                border-bottom: 1px solid white;
                box-sizing: border-box;
            }

            .Zicon {
                width: 73%;
                margin: auto;
                display: flex;
                flex-wrap: wrap;
                margin-top: 12px;
            }
        }
    }

    .right {
        width: 50%;
        height: 100%;

        .rightTop {
            width: 98%;
            height: 46%;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            display: flex;
            padding: 30px 20px;
            box-sizing: border-box;
        }

        .rightBottom {
            // margin-top: 16px;
            width: 98%;
            height: 90.5%;
            background-color: #EA6B4A;
            color: white;
            font-size: 14px;
            border-radius: 10px;
            padding: 52px 20px;
            box-sizing: border-box;
            display: flex;
        }
    }
}
</style>